
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {AccountSocialTradingMasterInsert2Response} from './AccountSocialTradingMasterInsert2Response';
import {Account} from '../core/Account';
import {FieldModelAccount} from '../core/Account';
import {AccountMarginStable} from '../entity/AccountMarginStable';
import {FieldModelAccountMarginStable} from '../entity/AccountMarginStable';
import {AccountLoginRangeParams} from './AccountLoginRangeParams';
import {FieldModelAccountLoginRangeParams} from './AccountLoginRangeParams';

/**
 * AccountSocialTradingMasterInsert2Request struct
 */
class AccountSocialTradingMasterInsert2Request extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Account=} account
   * @param {AccountMarginStable=} margin
   * @param {!number=} marginHistoryRecordOrderId
   * @param {Account=} commissionAccount
   * @param {AccountMarginStable=} commissionMargin
   * @param {number=} commissionMarginHistoryRecordOrderId
   * @param {!AccountLoginRangeParams=} suitableLoginRange
   * @param {AccountLoginRangeParams=} commissionSuitableLoginRange
   * @constructor
   */
  constructor (parent = new Request(), account = new Account(), margin = null, marginHistoryRecordOrderId = new UInt64(0, 0), commissionAccount = null, commissionMargin = null, commissionMarginHistoryRecordOrderId = null, suitableLoginRange = new AccountLoginRangeParams(), commissionSuitableLoginRange = null) {
    super()
    super.copy(parent)
    this.Account = account
    this.Margin = margin
    this.MarginHistoryRecordOrderId = marginHistoryRecordOrderId
    this.CommissionAccount = commissionAccount
    this.CommissionMargin = commissionMargin
    this.CommissionMarginHistoryRecordOrderId = commissionMarginHistoryRecordOrderId
    this.SuitableLoginRange = suitableLoginRange
    this.CommissionSuitableLoginRange = commissionSuitableLoginRange
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountSocialTradingMasterInsert2Request}
   * @param {!AccountSocialTradingMasterInsert2Request} other Other struct
   * @returns {!AccountSocialTradingMasterInsert2Request} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Account != null) {
      this.Account = Account.fromObject(other.Account)
    } else {
      this.Account = null
    }
    if (other.Margin != null) {
      this.Margin = AccountMarginStable.fromObject(other.Margin)
    } else {
      this.Margin = null
    }
    if (other.MarginHistoryRecordOrderId != null) {
      this.MarginHistoryRecordOrderId = UInt64.fromNumber(other.MarginHistoryRecordOrderId)
    } else {
      this.MarginHistoryRecordOrderId = null
    }
    if (other.CommissionAccount != null) {
      this.CommissionAccount = Account.fromObject(other.CommissionAccount)
    } else {
      this.CommissionAccount = null
    }
    if (other.CommissionMargin != null) {
      this.CommissionMargin = AccountMarginStable.fromObject(other.CommissionMargin)
    } else {
      this.CommissionMargin = null
    }
    if (other.CommissionMarginHistoryRecordOrderId != null) {
      this.CommissionMarginHistoryRecordOrderId = UInt64.fromNumber(other.CommissionMarginHistoryRecordOrderId)
    } else {
      this.CommissionMarginHistoryRecordOrderId = null
    }
    if (other.SuitableLoginRange != null) {
      this.SuitableLoginRange = AccountLoginRangeParams.fromObject(other.SuitableLoginRange)
    } else {
      this.SuitableLoginRange = null
    }
    if (other.CommissionSuitableLoginRange != null) {
      this.CommissionSuitableLoginRange = AccountLoginRangeParams.fromObject(other.CommissionSuitableLoginRange)
    } else {
      this.CommissionSuitableLoginRange = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountSocialTradingMasterInsert2Request}
   * @returns {!AccountSocialTradingMasterInsert2Request} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountSocialTradingMasterInsert2RequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountSocialTradingMasterInsert2RequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountSocialTradingMasterInsert2Request}
   * @param {!AccountSocialTradingMasterInsert2Request} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountSocialTradingMasterInsert2Request)) {
      throw new TypeError('Instance of AccountSocialTradingMasterInsert2Request is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountSocialTradingMasterInsert2Request}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Account: ((this.Account != null) ? this.Account : null),
      Margin: ((this.Margin != null) ? this.Margin : null),
      MarginHistoryRecordOrderId: ((this.MarginHistoryRecordOrderId != null) ? this.MarginHistoryRecordOrderId.toNumber() : null),
      CommissionAccount: ((this.CommissionAccount != null) ? this.CommissionAccount : null),
      CommissionMargin: ((this.CommissionMargin != null) ? this.CommissionMargin : null),
      CommissionMarginHistoryRecordOrderId: ((this.CommissionMarginHistoryRecordOrderId != null) ? this.CommissionMarginHistoryRecordOrderId.toNumber() : null),
      SuitableLoginRange: ((this.SuitableLoginRange != null) ? this.SuitableLoginRange : null),
      CommissionSuitableLoginRange: ((this.CommissionSuitableLoginRange != null) ? this.CommissionSuitableLoginRange : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountSocialTradingMasterInsert2Request.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountSocialTradingMasterInsert2Request} other Object value
   * @returns {!AccountSocialTradingMasterInsert2Request} Created struct
   */
  static fromObject (other) {
    return new AccountSocialTradingMasterInsert2Request().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountSocialTradingMasterInsert2Request}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountSocialTradingMasterInsert2Request.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountSocialTradingMasterInsert2Request}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4115
  }
}

export { AccountSocialTradingMasterInsert2Request };

/**
 * Fast Binary Encoding AccountSocialTradingMasterInsert2Request field model
 */
class FieldModelAccountSocialTradingMasterInsert2Request extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Account = new FieldModelAccount(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.Margin = new fbe.FieldModelOptional(new FieldModelAccountMarginStable(buffer, this.Account.fbeOffset + this.Account.fbeSize), buffer, this.Account.fbeOffset + this.Account.fbeSize)
    this.MarginHistoryRecordOrderId = new fbe.FieldModelUInt64(buffer, this.Margin.fbeOffset + this.Margin.fbeSize)
    this.CommissionAccount = new fbe.FieldModelOptional(new FieldModelAccount(buffer, this.MarginHistoryRecordOrderId.fbeOffset + this.MarginHistoryRecordOrderId.fbeSize), buffer, this.MarginHistoryRecordOrderId.fbeOffset + this.MarginHistoryRecordOrderId.fbeSize)
    this.CommissionMargin = new fbe.FieldModelOptional(new FieldModelAccountMarginStable(buffer, this.CommissionAccount.fbeOffset + this.CommissionAccount.fbeSize), buffer, this.CommissionAccount.fbeOffset + this.CommissionAccount.fbeSize)
    this.CommissionMarginHistoryRecordOrderId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.CommissionMargin.fbeOffset + this.CommissionMargin.fbeSize), buffer, this.CommissionMargin.fbeOffset + this.CommissionMargin.fbeSize)
    this.SuitableLoginRange = new FieldModelAccountLoginRangeParams(buffer, this.CommissionMarginHistoryRecordOrderId.fbeOffset + this.CommissionMarginHistoryRecordOrderId.fbeSize)
    this.CommissionSuitableLoginRange = new fbe.FieldModelOptional(new FieldModelAccountLoginRangeParams(buffer, this.SuitableLoginRange.fbeOffset + this.SuitableLoginRange.fbeSize), buffer, this.SuitableLoginRange.fbeOffset + this.SuitableLoginRange.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Account.fbeSize + this.Margin.fbeSize + this.MarginHistoryRecordOrderId.fbeSize + this.CommissionAccount.fbeSize + this.CommissionMargin.fbeSize + this.CommissionMarginHistoryRecordOrderId.fbeSize + this.SuitableLoginRange.fbeSize + this.CommissionSuitableLoginRange.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Account.fbeExtra + this.Margin.fbeExtra + this.MarginHistoryRecordOrderId.fbeExtra + this.CommissionAccount.fbeExtra + this.CommissionMargin.fbeExtra + this.CommissionMarginHistoryRecordOrderId.fbeExtra + this.SuitableLoginRange.fbeExtra + this.CommissionSuitableLoginRange.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountSocialTradingMasterInsert2Request.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4115
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Account.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Account.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Account.fbeSize

    if ((fbeCurrentSize + this.Margin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Margin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Margin.fbeSize

    if ((fbeCurrentSize + this.MarginHistoryRecordOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarginHistoryRecordOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginHistoryRecordOrderId.fbeSize

    if ((fbeCurrentSize + this.CommissionAccount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionAccount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionAccount.fbeSize

    if ((fbeCurrentSize + this.CommissionMargin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionMargin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionMargin.fbeSize

    if ((fbeCurrentSize + this.CommissionMarginHistoryRecordOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionMarginHistoryRecordOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionMarginHistoryRecordOrderId.fbeSize

    if ((fbeCurrentSize + this.SuitableLoginRange.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SuitableLoginRange.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SuitableLoginRange.fbeSize

    if ((fbeCurrentSize + this.CommissionSuitableLoginRange.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionSuitableLoginRange.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionSuitableLoginRange.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @param {!AccountSocialTradingMasterInsert2Request} fbeValue Default value, defaults is new AccountSocialTradingMasterInsert2Request()
   * @returns {!AccountSocialTradingMasterInsert2Request} AccountSocialTradingMasterInsert2Request value
   */
  get (fbeValue = new AccountSocialTradingMasterInsert2Request()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @param {!AccountSocialTradingMasterInsert2Request} fbeValue AccountSocialTradingMasterInsert2Request value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Account.fbeSize) <= fbeStructSize) {
      fbeValue.Account = this.Account.get()
    } else {
      fbeValue.Account = new Account()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Account.fbeSize

    if ((fbeCurrentSize + this.Margin.fbeSize) <= fbeStructSize) {
      fbeValue.Margin = this.Margin.get()
    } else {
      fbeValue.Margin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Margin.fbeSize

    if ((fbeCurrentSize + this.MarginHistoryRecordOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.MarginHistoryRecordOrderId = this.MarginHistoryRecordOrderId.get()
    } else {
      fbeValue.MarginHistoryRecordOrderId = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginHistoryRecordOrderId.fbeSize

    if ((fbeCurrentSize + this.CommissionAccount.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionAccount = this.CommissionAccount.get()
    } else {
      fbeValue.CommissionAccount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionAccount.fbeSize

    if ((fbeCurrentSize + this.CommissionMargin.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionMargin = this.CommissionMargin.get()
    } else {
      fbeValue.CommissionMargin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionMargin.fbeSize

    if ((fbeCurrentSize + this.CommissionMarginHistoryRecordOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionMarginHistoryRecordOrderId = this.CommissionMarginHistoryRecordOrderId.get()
    } else {
      fbeValue.CommissionMarginHistoryRecordOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionMarginHistoryRecordOrderId.fbeSize

    if ((fbeCurrentSize + this.SuitableLoginRange.fbeSize) <= fbeStructSize) {
      fbeValue.SuitableLoginRange = this.SuitableLoginRange.get()
    } else {
      fbeValue.SuitableLoginRange = new AccountLoginRangeParams()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SuitableLoginRange.fbeSize

    if ((fbeCurrentSize + this.CommissionSuitableLoginRange.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionSuitableLoginRange = this.CommissionSuitableLoginRange.get()
    } else {
      fbeValue.CommissionSuitableLoginRange = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionSuitableLoginRange.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @param {!AccountSocialTradingMasterInsert2Request} fbeValue AccountSocialTradingMasterInsert2Request value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountSocialTradingMasterInsert2Request}
   * @param {AccountSocialTradingMasterInsert2Request} fbeValue AccountSocialTradingMasterInsert2Request value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Account.set(fbeValue.Account)
    this.Margin.set(fbeValue.Margin)
    this.MarginHistoryRecordOrderId.set(fbeValue.MarginHistoryRecordOrderId)
    this.CommissionAccount.set(fbeValue.CommissionAccount)
    this.CommissionMargin.set(fbeValue.CommissionMargin)
    this.CommissionMarginHistoryRecordOrderId.set(fbeValue.CommissionMarginHistoryRecordOrderId)
    this.SuitableLoginRange.set(fbeValue.SuitableLoginRange)
    this.CommissionSuitableLoginRange.set(fbeValue.CommissionSuitableLoginRange)
  }
}

export { FieldModelAccountSocialTradingMasterInsert2Request };

/**
 * Fast Binary Encoding AccountSocialTradingMasterInsert2Request model
 */
class AccountSocialTradingMasterInsert2RequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountSocialTradingMasterInsert2Request(this.buffer, 4)
  }

  /**
   * Get the AccountSocialTradingMasterInsert2Request model
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @returns {!FieldModelAccountSocialTradingMasterInsert2Request} model AccountSocialTradingMasterInsert2Request model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountSocialTradingMasterInsert2RequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountSocialTradingMasterInsert2Request.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @param {!AccountSocialTradingMasterInsert2Request} value AccountSocialTradingMasterInsert2Request value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @param {!AccountSocialTradingMasterInsert2Request} value AccountSocialTradingMasterInsert2Request value, defaults is new AccountSocialTradingMasterInsert2Request()
   * @return {!object} Deserialized AccountSocialTradingMasterInsert2Request value and its size
   */
  deserialize (value = new AccountSocialTradingMasterInsert2Request()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountSocialTradingMasterInsert2Request(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountSocialTradingMasterInsert2Request(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountSocialTradingMasterInsert2RequestModel}
   * @param {!number} prev Previous AccountSocialTradingMasterInsert2Request model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountSocialTradingMasterInsert2RequestModel };
AccountSocialTradingMasterInsert2Request.__has_response = true;
AccountSocialTradingMasterInsert2Request.__response_class = AccountSocialTradingMasterInsert2Response;
